import React from "react"

import { useNavigate } from "react-router-dom"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { MFAType } from "../../../../config/auth.config"
import { useAppDispatch } from "../../../../store/appDispatch.hook"
import { useAppSelector } from "../../../../store/selectors/app.selector"
import { authSelector } from "../../../../store/selectors/auth.selector"
import { authProcessMfaCode } from "../../../../store/thunks/auth.thunks"
import { CodeForm } from "../../mfa/codeForm"

export const TOTPCodeStep: React.FunctionComponent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const authState = useAppSelector(authSelector)

    const onSubmit = (code: string, rememberDevice?: boolean) => {
        dispatch(
            authProcessMfaCode({
                payload: {
                    code,
                    withLoggingIn: true,
                    mfaType: MFAType.TOTP,
                    rememberDevice,
                },
                navigate,
            }),
        )
    }

    return (
        <div className="relative">
            <PrimaryText
                className="whitespace-pre-wrap mb-[24px]"
                typography="h3"
            >
                Multi-factor Authentication
            </PrimaryText>

            <PrimaryText
                className="whitespace-pre-wrap mb-[24px]"
                typography="text"
                size={20}
            >
                Enter the verification code from your authentication app.
            </PrimaryText>

            <CodeForm
                isCtaLoading={authState.isLoading}
                onSubmit={onSubmit}
                mfaType={MFAType.TOTP}
                submitText="Submit"
            />

            <PrimaryText size={14} lineHeight={21} className="max-w-[400px]">
                Trouble with MFA? Contact your organization’s administrator to
                help reset your MFA.
            </PrimaryText>
        </div>
    )
}
